import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminLogin } from './auth/AdminLogin.tsx';
import { CompanyLanding } from './auth/CompanyLanding.tsx';
import { CompanyCallback } from './auth/CompanyCallback.tsx';
import { CompanyExpired } from './auth/CompanyExpired.tsx';
import { NotFound } from './auth/NotFound.tsx';
import { AdminShell } from './admin/AdminShell.tsx';
import { AdminDashboard } from './admin/Dashboard.tsx';
import { AdminCompanies } from './admin/Companies.tsx';
import { AdminCompanyDetail } from './admin/CompanyDetail.tsx';
import { AdminQuestionBuilder } from './admin/QuestionBuilder.tsx';
import { AdminDocuments } from './admin/Documents.tsx';
import { AdminReviews } from './admin/Reviews.tsx';
import { AdminSettings } from './admin/Settings.tsx';
import { AdminActivity } from './admin/Activity.tsx';
import { AdminUsers } from './admin/Users.tsx';
import { CompanyShell } from './company/CompanyShell.tsx';
import { CompanyDashboard } from './company/Dashboard.tsx';
import { CompanyInformation } from './company/CompanyInfo.tsx';
import { Questionnaire } from './company/Questionnaire.tsx';
import { MyDocuments } from './company/MyDocuments.tsx';
import { CompanyActivity } from './company/Activity.tsx';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/admin" replace />} />

      {/* Auth */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/c/:token" element={<CompanyLanding />} />
      <Route path="/c/callback" element={<CompanyCallback />} />
      <Route path="/c/expired" element={<CompanyExpired />} />

      {/* Admin */}
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<AdminDashboard />} />
        <Route path="companies" element={<AdminCompanies />} />
        <Route path="companies/:id" element={<AdminCompanyDetail />} />
        <Route path="questions" element={<AdminQuestionBuilder />} />
        <Route path="documents" element={<AdminDocuments />} />
        <Route path="reviews" element={<AdminReviews />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="settings" element={<AdminSettings />} />
        <Route path="activity" element={<AdminActivity />} />
      </Route>

      {/* Company */}
      <Route path="/c" element={<CompanyShell />}>
        <Route index element={<CompanyDashboard />} />
        <Route path="info" element={<CompanyInformation />} />
        <Route path="questionnaire" element={<Questionnaire />} />
        <Route path="documents" element={<MyDocuments />} />
        <Route path="activity" element={<CompanyActivity />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
